import Link from "next/link";
import { useContext } from "react";
import { MenuContext, MenuContextType } from ".";
import { routes, services } from "../../pageNames";
import { loraItalic } from "@/app/styles/fonts";

const PlusSVG: React.FC<{ servicesOpen: boolean }> = ({ servicesOpen }) => (
  <svg
    focusable="false"
    width="1.5rem"
    height="1.5rem"
    viewBox="0 0 44 44"
    aria-hidden="true"
    className="absolute ml-24 fill-olive group-hover:fill-gold group3:ml-16 mr-4 group4:ml-20 "
  >
    <path d="M8 21h28v2H8z" />
    {!servicesOpen && <path d="M21 8v28h2V8z" />}
  </svg>
);
interface ServicesProps {
  key: string;
}

const Services: React.FC<ServicesProps> = () => {
  const menuContext = useContext(MenuContext);
  const { servicesOpen, setServicesOpen, setMenuOpen } =
    menuContext as MenuContextType;
  const serviceItems = services.map((service, index) => (
    <li
      key={"desktopservice" + service + index}
      className="my-4 hover:text-gold hover:underline has-[:focus-visible]:ring has-[:focus-visible]:ring-olive has-[:focus-visible]:ring-offset-8 "
    >
      <Link
        href={"/services#" + service.route.replace(/\s+/g, "").toLowerCase()}
        onClick={() => {
          setMenuOpen(false);
          setServicesOpen(false);
        }}
        className={"focus:outline-none mx-1 "}
      >
        {service.name}
      </Link>
    </li>
  ));
  return (
    <li className="contents group3:flex group3:flex-col items-center mr-6">
      <button
        className={`group flex ${
          servicesOpen ? "mb-0" : "mb-16"
        } ml-[1.5rem] flex-row items-center hover:text-gold hover:underline focus:outline-none focus-visible:ring focus-visible:ring-olive focus-visible:ring-offset-4 group3:mb-0`}
        onClick={() => {
          setServicesOpen(!servicesOpen);
        }}
        aria-expanded={servicesOpen ? true : false}
      >
        Services
        <PlusSVG servicesOpen={servicesOpen} />
      </button>
      <ul
        className={`${
          !servicesOpen
            ? "hidden"
            : `flex flex-col my-4 items-center text-lg  group3:absolute group3:text-l group3:mt-[1.5rem] group4:mt-[3.65rem] group3:bg-white group3:p-4 `
        }`}
      >
        {serviceItems}
        <li
          key={"desktopservice" + "designprocess"}
          className="my-4 hover:text-gold hover:underline has-[:focus-visible]:ring has-[:focus-visible]:ring-olive has-[:focus-visible]:ring-offset-8 "
        >
          <Link
            href={"/designprocess"}
            onClick={() => {
              setMenuOpen(false);
              setServicesOpen(false);
            }}
            className={"focus:outline-none mx-1 "}
          >
            The Design Process
          </Link>
        </li>
      </ul>
    </li>
  );
};

export default function NavItems() {
  const menuContext = useContext(MenuContext);
  const { setMenuOpen, setServicesOpen } = menuContext as MenuContextType;

  const items = (
    <ul className="group3:flex  items-center group3:w-full justify-evenly">
      {routes.slice(0, 4).map((route, index) => (
        <li
          key={"desktop" + route + index}
          className="mb-16 hover:text-gold hover:underline has-[:focus-visible]:ring has-[:focus-visible]:ring-olive has-[:focus-visible]:ring-offset-8 first:mt-[12rem] group3:first:my-4 group3:mb-0"
        >
          <Link
            href={"/" + route.replace(/\s+/g, "").toLowerCase()}
            onClick={() => {
              setMenuOpen(false);
              setServicesOpen(false);
            }}
            className={"focus:outline-none text-wrap"}
          >
            {route}
          </Link>
        </li>
      ))}
    </ul>
  );
  const items2 = (
    <ul className="group3:flex items-center group3:w-full  justify-around">
      {routes.slice(4, 7).map((route, index) =>
        route === "Services" ? (
          <Services key={route} />
        ) : (
          <li
            key={"desktop" + route + index}
            className="mb-16 hover:text-gold hover:underline has-[:focus-visible]:ring has-[:focus-visible]:ring-olive has-[:focus-visible]:ring-offset-8 first:mt-[12rem] group3:first:my-4 group3:mb-0"
          >
            <Link
              href={"/" + route.replace(/\s+/g, "").toLowerCase()}
              onClick={() => {
                setMenuOpen(false);
                setServicesOpen(false);
              }}
              className={"focus:outline-none text-wrap"}
            >
              {route}
            </Link>
          </li>
        )
      )}
    </ul>
  );

  return (
    <>
      {items}
      {items2}
    </>
  );
}
